import React from "react";
import Header from "./Header";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Form, Space } from "@masterteam/mt-design-react";
import { object, string } from "yup";
// import {
//   appStoreURL,
//   playStoreURL,
// } from "../../../../providers/config/urlServiceConfig";
// import AppsStoreIcon from "../../../../assets/images/app-store.svg";
// import GooglePlayIcon from "../../../../assets/images/google-play.svg";
import { ReactComponent as SwitchLangIcon } from "../../../../assets/images/global.svg";

import { useDispatch } from "react-redux";
import { toggleLanguage } from "../../../../reducers/language";
import useIsAr from "../../../../Hooks/useIsAr";
import styles from "./LoginForm.module.scss";

function LoginForm({ onSubmit, loading }) {
  const intl = useIntl();
  const { Field } = Form;
  const dispatch = useDispatch();

  const validationLoginSchema = () => {
    return object().shape({
      username: string().required(" "),
      password: string().required(" "),
    });
  };

  const handleLanguage = () => {
    dispatch(toggleLanguage());
  };

  const [isAr] = useIsAr();

  return (
    <div className={styles.rightSide}>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          width: "100%",
          padding: "0 20px",
        }}
      >
        <Button
          variant="dark"
          fill="none"
          size="medium"
          onClick={() => handleLanguage()}
          tooltip-position="buttom"
          tooltip={isAr ? "اللغات" : "Languages"}
        >
          <div style={{ display: "flex", aligItems: "center", gap: "8px" }}>
            {isAr ? "English" : "العربية"}
            <SwitchLangIcon width={16} />
          </div>
        </Button>
      </div>
      <div className={styles.content}>
        <div>
          <Header />

          <Form
            layout="dynamic"
            size="large"
            onSubmit={onSubmit}
            validationSchema={validationLoginSchema}
            initialValues={{
              username: "",
              password: "",
            }}
          >
            <Field
              name="username"
              type="text"
              inputProps={{
                placeholder: intl.formatMessage({
                  id: "login-page.username",
                }),
              }}
              label={intl.formatMessage({ id: "login-page.username" })}
            />
            <Field
              name="password"
              type="password"
              inputProps={{
                placeholder: intl.formatMessage({
                  id: "login-page.password",
                }),
              }}
              label={intl.formatMessage({ id: "login-page.password" })}
            />
            <div className={styles.loginBtn}>
              <Button
                disabled={loading}
                variant="primary"
                loading={loading}
                type="submit"
                size="large"
                block
                backgroundColor="#119E50"
              >
                <FormattedMessage id="login-page.login" />{" "}
              </Button>
            </div>
          </Form>

          <Space
            className={styles.msarText}
            direction="vertical"
            align="center"
            gap={12}
          >
            <div>
              <span className="bold">
                <FormattedMessage id="login-page.msar" />
              </span>{" "}
              <FormattedMessage id="login-page.msar-text" />
            </div>

            <div>
              <span className="bold">MSAR</span>{" "}
              <FormattedMessage id="login-page.msar-abbreviation" />
            </div>
          </Space>
        </div>

        {/* <Row
          size="medium"
          align="center"
          justify="center"
          className={styles.mobileContainer}
        >
          <a
            href={playStoreURL}
            target="_blank"
            rel="noopener noreferrer"
            className="google-play"
          >
            <img src={GooglePlayIcon} alt="play store" />
          </a>
          <a
            href={appStoreURL}
            target="_blank"
            rel="noopener noreferrer"
            className="app-store"
          >
            <img src={AppsStoreIcon} alt="app store" />
          </a>
        </Row> */}
      </div>
    </div>
  );
}

export default LoginForm;
